<template>
	<div class="home" @mousemove="parallax">
		<div class="bg" v-bg="'home/bg.png'"></div>
		<div class="home-content" ref="scene">
			<img class="character spider" id="spider" v-bg="'home/spider.png'" />
			<img class="character barrel" id="barrel" v-bg="'home/barrel.png'" />
			<img class="character fish" id="fish" v-bg="'home/fish.png'" />
		</div>
		<div class="logo" v-bg="'logo.png'"></div>
		<div class="hint" v-hammer:tap="fullscreen"><span class="letter">[F]</span> {{ 'fullscreen' | lang }}</div>
		<div class="buttons">
			<div class="button" v-hammer:tap="start">
				<div class="button-content" v-bg="'home/button.png'">{{ 'start' | lang }}</div>
			</div>
			<div class="button" v-hammer:tap="settings">
				<div class="button-content" v-bg="'home/button.png'">{{ 'settings' | lang }}</div>
			</div>
			<div class="button" v-hammer:tap="credits">
				<div class="button-content" v-bg="'home/button.png'">{{ 'credits' | lang }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import Sounds from '@/js/sounds'

let $spider = null
let $barrel = null
let $fish = null

export default {
	name: 'home',
	methods: {
		start() {
			Sounds.play('button')
			this.$router.push({ name: 'heroes' })
		},
		settings() {
			this.$store.dispatch('add_popup', { type: 'settings' })
		},
		credits() {
			this.$store.dispatch('add_popup', { type: 'credits' })
		},
		parallax(e) {
			$spider.style.transform = 'translate(' + (e.pageX / 200) + 'px, ' + (e.pageY / 200) + 'px)'
			$barrel.style.transform = 'translate(' + (e.pageX / 100) + 'px, ' + (e.pageY / 100) + 'px)'
			$fish.style.transform   = 'translate(' + (e.pageX / 150) + 'px, ' + (e.pageY / 150) + 'px)'
		},
		fullscreen: function() {
			const elem = document.documentElement
			if (elem.requestFullscreen) elem.requestFullscreen()
			else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen()
			else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen()
			else if (elem.msRequestFullscreen) elem.msRequestFullscreen()
		},
	},
	mounted() {
		$spider = document.querySelector('#spider')
		$barrel = document.querySelector('#barrel')
		$fish = document.querySelector('#fish')
	},
	created() {
		this.$store.dispatch('check_unlocks')
	}
}
</script>

<style lang="stylus" scoped>

.home
	height 100%
	width 100%
	flex center center
	font-size 4rem
	.bg
		absolute 0
		background-size cover
	.hint
		position absolute
		right 32px
		bottom 32px
		color #fff
		transition 0.1s easeOutQuart
		&:hover
			color dark
		.letter
			margin 0 8px 0 0
	.home-content
		absolute 0
		pointer-events none
		.character
			position absolute
			left -32px
			bottom -32px
			transition transform 0.1s 
			&.fish
				left -64px
				height calc(100% + 64px)
				// width (930px * 1.05)
				// height (1080px * 1.05)
			&.barrel
				left 11%
				// height 976px
				height 60%
			&.spider
				left 44%
				height 60%
				// height 644px

	.logo
		position absolute
		right 32px
		top 64px
		width round(796px / 1.3)
		height round(582px / 1.3)
		background center center no-repeat
		background-size contain
	.buttons
		position absolute
		right 130px
		top 70%
		transform translateY(-50%)
		.button
			margin 0 0 16px 0
			&:hover
				.button-content
					transform scale(1.02)
			&:active
				.button-content
					transform scale(0.98)
			.button-content
				width 100%
				height 100%
				width 380px
				height 78px
				flex center center
				color #fff
				transition 0.05s easeOutQuart
	

</style>
